import React from "react";

/**
 * Original ULI monogram — an elegant serif "UL" set within a fine ring,
 * with a small gold marker. Timeless, boutique-investment feel.
 * No houses, roofs, mountains, trees, or location pins.
 */
export const Logo = ({ dark = false, className = "" }) => {
  const fg = dark ? "#0D1C13" : "#F4F0E6";
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <svg width="42" height="42" viewBox="0 0 48 48" fill="none" aria-hidden="true">
        <circle cx="24" cy="24" r="22.25" stroke={fg} strokeWidth="1" opacity="0.85" />
        <circle cx="24" cy="24" r="18.5" stroke={fg} strokeWidth="0.5" opacity="0.35" />
        <text
          x="24"
          y="24"
          textAnchor="middle"
          dominantBaseline="central"
          fontFamily="'Cormorant Garamond', serif"
          fontSize="20"
          fontWeight="600"
          letterSpacing="0.5"
          fill={fg}
        >
          UL
        </text>
        <circle cx="24" cy="41.5" r="1.4" fill="#C25E4A" />
      </svg>
      <div className="leading-none">
        <span className="block font-display text-[19px] tracking-[0.12em] uppercase" style={{ color: fg }}>
          Urbina
        </span>
        <span className="block font-body text-[8.5px] uppercase tracking-[0.42em] mt-1" style={{ color: "#C25E4A" }}>
          Land Investments
        </span>
      </div>
    </div>
  );
};
